import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: { theme: 'light' | 'dark'; filterWrapperStatus: 'open' | 'close'; fullScreen: boolean; showNotifications: any; trackingTimeType: string } = {
  theme: (localStorage.getItem('theme') as 'light' | 'dark') || 'light',
  filterWrapperStatus: (localStorage.getItem('filterWrapperStatus') as 'open' | 'close') || 'close',
  fullScreen: false,
  showNotifications: localStorage.getItem('showNotifications') || 'hidden',
  trackingTimeType: localStorage.getItem('trackingTimeType') || 'device',
};

export const settingSlice = createSlice({
  name: 'setting',
  initialState: initialState,

  reducers: {
    setSettingTrackingTimeType: (state, { payload }) => {
      if (payload !== 'device' && payload !== 'server' && payload !== 'both') return;
      localStorage.setItem('trackingTimeType', payload);
      state.trackingTimeType = payload;
    },
    setSettingSwitchTheme: (state) => {
      const newTheme = state.theme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', newTheme);

      state.theme = newTheme;
    },
    setSettingSwitchFilterWrapperStatus: (state) => {
      const newSatus = state.filterWrapperStatus === 'close' ? 'open' : 'close';
      // console.log(newSatus);
      localStorage.setItem('filterWrapperStatus', newSatus);

      state.filterWrapperStatus = newSatus;
    },
    setSettingFullScreen: (state, { payload }: PayloadAction<boolean>) => {
      state.fullScreen = payload;
    },
    setSettingSwitchShowNotificationsStatus: (state) => {
      const newSatus = state.showNotifications === 'hidden' ? 'show' : 'hidden';
      localStorage.setItem('showNotifications', newSatus);

      state.showNotifications = newSatus;
    },
  },
});

export const { setSettingSwitchTheme, setSettingFullScreen, setSettingSwitchFilterWrapperStatus, setSettingSwitchShowNotificationsStatus, setSettingTrackingTimeType } =
  settingSlice.actions;
export default settingSlice.reducer;
